import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Workflow } from '../../../types/Workflow.type';
import { WorkflowService } from '../workflow.service';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-configuracao-workflow',
  templateUrl: './configuracao-workflow.component.html',
  styleUrl: './configuracao-workflow.component.css'
})
export class ConfiguracaoWorkflowComponent implements OnInit {

  loading: boolean = false;
  workflows: Workflow[] = [];

  constructor(
    private router: Router,
    private workflowService: WorkflowService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.carregarWorkflows();
  }

  carregarWorkflows() {
    this.loading = true;

    this.workflowService.getWorkflows().subscribe({
      next: (data) => {
        this.workflows = data;
      },
      error: (erro) => {
        this.toastService.erro('Erro', 'Erro ao carregar workflows: ' + erro.error?.message);
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  editarWorkflow(workflow: Workflow) {
    this.router.navigate(['/administracao/workflows/editar', workflow.id]);
  }

  formatarNomeEntidade(entidade: string): string {
    return entidade
      .split('_')
      .map(palavra => palavra.charAt(0) + palavra.slice(1).toLowerCase())
      .join(' ')
      .replace('Provisao', 'Provisão')
      .replace('Estornar', 'Estorno');
  }
}
